import { render, staticRenderFns } from "./traditionalMedicine.vue?vue&type=template&id=1d352760&scoped=true&"
import script from "./traditionalMedicine.vue?vue&type=script&lang=ts&"
export * from "./traditionalMedicine.vue?vue&type=script&lang=ts&"
import style0 from "./traditionalMedicine.vue?vue&type=style&index=0&id=1d352760&lang=scss&scoped=true&"
import style1 from "./traditionalMedicine.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d352760",
  null
  
)

export default component.exports